/**
 * @copyright Copyright (c) 2016, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:dbarreto@pacificbiosciences.com">David Barreto</a>
 */

export const aboutTranslations = {
    title: "About",
    subtitle: "Software Component Versions",
    connectionError: "Error connecting to server",
    loading: "Loading&hellip;",
    smrtLinkUI: "SMRT Link UI",
    sequelApiServer: "Sequel API Server",
    smrtLinkWebServices: "SMRT Link Web Services",
    smrtLinkSystemID: "SMRT Link System ID",
    smrtLinkLastUpdate: "SMRT Link Latest Update",
    additionalInfo: "Additional Information",
    versionsForAllComponents: "Versions For All Components",
    smrtLinkBackendHost: "SMRT Link URL",
    smrtLinkBackendPort: "SMRT Link Services Port"
}
